
class AnimatedInfoList {
  constructor(section) {
    this.section = section;
    this.numbers = section.querySelectorAll('.animated-info-list__number');
    this.observer = null;
    this.hasAnimated = false;
  }

  init() {
    if (!this.numbers.length) return;

    // Use Intersection Observer to trigger animation when in viewport
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateNumbers();
            this.hasAnimated = true;
          }
        });
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this.section);
  }

  animateNumbers() {
    this.numbers.forEach((numberEl) => {
      const target = parseFloat(numberEl.getAttribute('data-target'));
      const duration = parseInt(numberEl.getAttribute('data-duration')) || 2000;
      
      if (isNaN(target)) return;

      this.animateValue(numberEl, 0, target, duration);
    });
  }

  animateValue(element, start, end, duration) {
    const startTime = performance.now();
    const isDecimal = end % 1 !== 0;
    const decimalPlaces = isDecimal ? end.toString().split('.')[1]?.length || 1 : 0;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const current = start + (end - start) * easeOut;

      // Format number with proper decimals and commas
      if (isDecimal) {
        element.textContent = current.toFixed(decimalPlaces);
      } else {
        element.textContent = Math.floor(current).toLocaleString('en-US');
      }

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final value is exact
        if (isDecimal) {
          element.textContent = end.toFixed(decimalPlaces);
        } else {
          element.textContent = Math.floor(end).toLocaleString('en-US');
        }
        element.setAttribute('data-animated', 'true');
      }
    };

    requestAnimationFrame(animate);
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Initialize all sections
function initAllSections() {
  document.querySelectorAll('.animated-info-list').forEach((section) => {
    const instance = new AnimatedInfoList(section);
    instance.init();
    section.__animatedInfoInstance = instance;
  });
}

// Initialize on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSections);
} else {
  initAllSections();
}

// Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.animated-info-list');
  if (section) {
    const instance = new AnimatedInfoList(section);
    instance.init();
    section.__animatedInfoInstance = instance;
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('.animated-info-list');
  if (section && section.__animatedInfoInstance) {
    section.__animatedInfoInstance.destroy();
    delete section.__animatedInfoInstance;
  }
});

